import { render, staticRenderFns } from "./DonationView.vue?vue&type=template&id=8627eb66&scoped=true"
import script from "./DonationView.vue?vue&type=script&lang=js"
export * from "./DonationView.vue?vue&type=script&lang=js"
import style0 from "./DonationView.vue?vue&type=style&index=0&id=8627eb66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8627eb66",
  null
  
)

export default component.exports